import { render, staticRenderFns } from "./set_main_credit_card.vue?vue&type=template&id=5a151f9f&lang=pug&"
import script from "./set_main_credit_card.vue?vue&type=script&lang=js&"
export * from "./set_main_credit_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports